{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Templates",
    "DESCRIPTION": "View the message templates synced from your WhatsApp inboxes. To create or edit a template, manage it with your provider.",
    "COUNT": "{n} template | {n} templates",
    "LEARN_MORE": "Learn more about WhatsApp templates",
    "SYNC_TEMPLATES": "Sync templates",
    "SYNC_SUCCESS": "Template sync started for all WhatsApp inboxes. Updates may take a couple of minutes.",
    "PARTIAL_SYNC_ERROR": "Template sync started for some WhatsApp inboxes, but others could not be synced.",
    "SYNC_ERROR": "Unable to start template sync. Please try again.",
    "SEARCH_PLACEHOLDER": "Search by content or name...",
    "MANAGE_IN_META": "Manage in Meta",
    "LOADING": "Loading WhatsApp templates...",
    "EMPTY": "No WhatsApp templates found.",
    "NO_RESULTS": "No templates match your filters.",
    "FETCH_ERROR": "Unable to load WhatsApp templates. Please try again.",
    "PARTIAL_FETCH_ERROR": "Some WhatsApp templates could not be loaded. Please try again.",
    "LAST_SYNC_ATTEMPT": "Last sync attempt on {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Not submitted for WhatsApp approval"
    },
    "FILTERS": {
      "ALL_INBOXES": "All inboxes",
      "ALL_LANGUAGES": "All languages",
      "ALL_TYPES": "All types"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Image",
      "VIDEO": "Video",
      "DOCUMENT": "Document",
      "CALL_TO_ACTION": "Call to action",
      "COPY_CODE": "Copy code"
    },
    "PREVIEW": {
      "TITLE": "Template preview",
      "DESCRIPTION": "Preview how this template appears in WhatsApp.",
      "OPEN": "Preview {name}",
      "CLOSE": "Close preview",
      "DETAILS": "Template details",
      "STATUS": "Status",
      "TYPE": "Content type",
      "CATEGORY": "Category",
      "LANGUAGE": "Language",
      "INBOXES": "Inboxes"
    }
  }
}
